"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListItemResponseTriggerToJSON = exports.TemplateGalleryListItemResponseTriggerToJSONJoined = exports.TemplateGalleryListItemResponseTriggerFromJSONTyped = exports.TemplateGalleryListItemResponseTriggerFromJSON = exports.instanceOfTemplateGalleryListItemResponseTrigger = exports.TemplateGalleryListItemResponseTriggerOperatorEnum = exports.attributeTypeMapTemplateGalleryListItemResponseTrigger = void 0;
var TemplateGalleryListItemResponseTriggerAny_1 = require("./TemplateGalleryListItemResponseTriggerAny");
var TemplateGalleryListItemResponseTriggerGt_1 = require("./TemplateGalleryListItemResponseTriggerGt");
var TemplateGalleryListItemResponseTriggerHas_1 = require("./TemplateGalleryListItemResponseTriggerHas");
var TemplateGalleryListItemResponseTriggerHasNot_1 = require("./TemplateGalleryListItemResponseTriggerHasNot");
var TemplateGalleryListItemResponseTriggerIs_1 = require("./TemplateGalleryListItemResponseTriggerIs");
var TemplateGalleryListItemResponseTriggerLt_1 = require("./TemplateGalleryListItemResponseTriggerLt");
var TemplateGalleryListItemResponseTriggerMatch_1 = require("./TemplateGalleryListItemResponseTriggerMatch");
var TemplateGalleryListItemResponseTriggerNone_1 = require("./TemplateGalleryListItemResponseTriggerNone");
var TemplateGalleryListItemResponseTriggerNot_1 = require("./TemplateGalleryListItemResponseTriggerNot");
exports.attributeTypeMapTemplateGalleryListItemResponseTrigger = [
    {
        name: "id",
        type: "string",
    },
    {
        name: "operator",
        type: "string",
    },
];
/**
 * @export
 */
exports.TemplateGalleryListItemResponseTriggerOperatorEnum = {
    Is: "is",
    Not: "not",
    Gt: "gt",
    Lt: "lt",
    Has: "has",
    HasNot: "hasNot",
    Match: "match",
    Any: "any",
    None: "none",
};
/**
 * Check if a given object implements the TemplateGalleryListItemResponseTrigger interface.
 */
function instanceOfTemplateGalleryListItemResponseTrigger(value) {
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("operator" in value) || value["operator"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateGalleryListItemResponseTrigger = instanceOfTemplateGalleryListItemResponseTrigger;
function TemplateGalleryListItemResponseTriggerFromJSON(json) {
    return TemplateGalleryListItemResponseTriggerFromJSONTyped(json, false);
}
exports.TemplateGalleryListItemResponseTriggerFromJSON = TemplateGalleryListItemResponseTriggerFromJSON;
function TemplateGalleryListItemResponseTriggerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json["operator"] === "any") {
            return (0, TemplateGalleryListItemResponseTriggerAny_1.TemplateGalleryListItemResponseTriggerAnyFromJSONTyped)(json, true);
        }
        if (json["operator"] === "gt") {
            return (0, TemplateGalleryListItemResponseTriggerGt_1.TemplateGalleryListItemResponseTriggerGtFromJSONTyped)(json, true);
        }
        if (json["operator"] === "has") {
            return (0, TemplateGalleryListItemResponseTriggerHas_1.TemplateGalleryListItemResponseTriggerHasFromJSONTyped)(json, true);
        }
        if (json["operator"] === "hasNot") {
            return (0, TemplateGalleryListItemResponseTriggerHasNot_1.TemplateGalleryListItemResponseTriggerHasNotFromJSONTyped)(json, true);
        }
        if (json["operator"] === "is") {
            return (0, TemplateGalleryListItemResponseTriggerIs_1.TemplateGalleryListItemResponseTriggerIsFromJSONTyped)(json, true);
        }
        if (json["operator"] === "lt") {
            return (0, TemplateGalleryListItemResponseTriggerLt_1.TemplateGalleryListItemResponseTriggerLtFromJSONTyped)(json, true);
        }
        if (json["operator"] === "match") {
            return (0, TemplateGalleryListItemResponseTriggerMatch_1.TemplateGalleryListItemResponseTriggerMatchFromJSONTyped)(json, true);
        }
        if (json["operator"] === "none") {
            return (0, TemplateGalleryListItemResponseTriggerNone_1.TemplateGalleryListItemResponseTriggerNoneFromJSONTyped)(json, true);
        }
        if (json["operator"] === "not") {
            return (0, TemplateGalleryListItemResponseTriggerNot_1.TemplateGalleryListItemResponseTriggerNotFromJSONTyped)(json, true);
        }
    }
    return {
        id: json["id"],
        operator: json["operator"],
    };
}
exports.TemplateGalleryListItemResponseTriggerFromJSONTyped = TemplateGalleryListItemResponseTriggerFromJSONTyped;
function TemplateGalleryListItemResponseTriggerToJSONJoined(value) {
    if (value == null) {
        return value;
    }
    if (value["operator"] === "any") {
        return (0, TemplateGalleryListItemResponseTriggerAny_1.TemplateGalleryListItemResponseTriggerAnyToJSON)(value);
    }
    if (value["operator"] === "gt") {
        return (0, TemplateGalleryListItemResponseTriggerGt_1.TemplateGalleryListItemResponseTriggerGtToJSON)(value);
    }
    if (value["operator"] === "has") {
        return (0, TemplateGalleryListItemResponseTriggerHas_1.TemplateGalleryListItemResponseTriggerHasToJSON)(value);
    }
    if (value["operator"] === "hasNot") {
        return (0, TemplateGalleryListItemResponseTriggerHasNot_1.TemplateGalleryListItemResponseTriggerHasNotToJSON)(value);
    }
    if (value["operator"] === "is") {
        return (0, TemplateGalleryListItemResponseTriggerIs_1.TemplateGalleryListItemResponseTriggerIsToJSON)(value);
    }
    if (value["operator"] === "lt") {
        return (0, TemplateGalleryListItemResponseTriggerLt_1.TemplateGalleryListItemResponseTriggerLtToJSON)(value);
    }
    if (value["operator"] === "match") {
        return (0, TemplateGalleryListItemResponseTriggerMatch_1.TemplateGalleryListItemResponseTriggerMatchToJSON)(value);
    }
    if (value["operator"] === "none") {
        return (0, TemplateGalleryListItemResponseTriggerNone_1.TemplateGalleryListItemResponseTriggerNoneToJSON)(value);
    }
    if (value["operator"] === "not") {
        return (0, TemplateGalleryListItemResponseTriggerNot_1.TemplateGalleryListItemResponseTriggerNotToJSON)(value);
    }
}
exports.TemplateGalleryListItemResponseTriggerToJSONJoined = TemplateGalleryListItemResponseTriggerToJSONJoined;
function TemplateGalleryListItemResponseTriggerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        operator: value["operator"],
    };
}
exports.TemplateGalleryListItemResponseTriggerToJSON = TemplateGalleryListItemResponseTriggerToJSON;
